import MyRoutesModule from './MyRoutesModule'
export default MyRoutesModule



// WEBPACK FOOTER //
// ./src/components/routes/MyRoutesModule/index.js